<template>
  <b-modal
      id="1"
      :title="title"
      v-model="isOpenLocal"
      size="lg"
      scrollable
      :hide-footer="hideFooter"
      :ok-title="capitalize($t('validate'))"
      :cancel-title="capitalize($t('cancel'))"
      @hide="tryCloseReminderModal"
      @hidden="handleCancel"
      @ok="handleOk"
  >
    <validation-observer
        ref="observerRef"
        #default="{handleSubmit, errors}"
    >
      <b-form
          @keydown.enter.stop.prevent=""
          @submit.prevent="handleSubmit(submitValidatedReminderLocal)"
      >
        <reminder-form
            :reminder.sync="reminderLocal"
            :is-template="isTemplate"

            @removeReminder="$emit('removeReminder')"
        />
        <button
            ref="submitReminderFormRef"
            class="d-none"
        ></button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { ValidationObserver }   from 'vee-validate'
import { capitalize }           from '../../utils/filter'

// import FormReminder from '@/components/form/reminder/Reminder'
import useAPI       from '../../utils/useAPI'
import ReminderForm from '../form/reminders/ReminderForm.vue'
import { clone }    from '../../utils/utils'

export default {
  components: {
    ValidationObserver,
    ReminderForm
  },
  props: {
    reminder: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isTemplate: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    // console.log(clone(props.reminder))
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const isOpenLocal = ref(false)
    const reminderLocal = ref(props.reminder)
    const submitReminderFormRef = ref(null)
    const observerRef = ref(null)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const { currentBreakPoint } = useAPI()

    const hideFooter = computed(() => {
      return !['xs', 'sm'].includes(currentBreakPoint.value)
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(isOpenLocal, (val) => {
      emit('update:isOpen', val)
    })
    watch(reminderLocal, (val) => {
      emit('update:reminder', val)
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const tryCloseReminderModal = (modalEvent) => {
      if (modalEvent.trigger == 'backdrop') {
        // Click outside
        modalEvent.preventDefault()
        submitReminderFormRef.value.click()
      }
    }

    const submitValidatedReminderLocal = () => {
      emit('submitValidatedReminder')
    }

    const handleOk = async (bvModalEvent) => {
      bvModalEvent.preventDefault()

      const isValid = await observerRef.value.validate()
      if (isValid) {
        submitValidatedReminderLocal()
      }
    }

    const handleCancel = () => {}

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,

      // Data
      isOpenLocal,
      reminderLocal,
      submitReminderFormRef,
      observerRef,

      // Computed
      hideFooter,

      // Methods
      tryCloseReminderModal,
      submitValidatedReminderLocal,
      handleOk,
      handleCancel,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {
    reminder: function (val) {
      this.reminderLocal = val
    },
    isOpen: function (val) {
      this.isOpenLocal = val
    },
  },
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">
.modal-body {
  background-color: #f8f8f8;
}
</style>